"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../../utils/api");
var stbActivateDevice_1 = __importDefault(require("./queries/stbActivateDevice"));
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
var config_1 = __importStar(require("../../config"));
var stbActivateDeviceAsync_1 = __importDefault(require("./queries/stbActivateDeviceAsync"));
exports.initiateDeviceActivation = function (value) {
    return toolkit_1.createAction(constants_1.SET_INITIATE_DEVICE_ACTIVATION)({ value: value });
};
exports.activateStbDevice = function (serialNumber, chipId) {
    return api_1.createApiAction(constants_1.ACTIVATE_STB_DEVICE, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: stbActivateDevice_1.default,
            variables: { serialNumber: serialNumber, chipId: chipId },
        },
        authenticated: true,
        graphQL: true,
    });
};
exports.activateStbDeviceAsync = function (serialNumber, appId) {
    return api_1.createApiAction(constants_1.ACTIVATE_STB_DEVICE_ASYNC, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: stbActivateDeviceAsync_1.default,
            variables: { appId: appId, serialNumber: serialNumber },
        },
        authenticated: true,
        graphQL: true,
    });
};
//# sourceMappingURL=actions.js.map